/**
 * Audits Monthly Chart Component
 * Displays monthly evolution of completed audits comparing 3 seasons (line chart)
 */

import { Card } from 'antd';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import type { MonthlyEvolution } from '../../services/api/auditsDashboardService';

interface AuditsMonthlyChartProps {
  data: MonthlyEvolution[];
}

export const AuditsMonthlyChart: React.FC<AuditsMonthlyChartProps> = ({ data }) => {
  // Group data by month and season
  const groupedByMonth: { [key: number]: any } = {};
  
  // Initialize all months
  for (let i = 1; i <= 12; i++) {
    groupedByMonth[i] = {
      month: i,
      month_name: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 
                   'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'][i - 1]
    };
  }
  
  // Fill with data
  data.forEach(item => {
    groupedByMonth[item.month][`year_${item.season_year}`] = item.count;
  });
  
  // Convert to array
  const chartData = Object.values(groupedByMonth);
  
  // Get unique years and sort descending
  const years = Array.from(new Set(data.map(item => item.season_year))).sort((a, b) => b - a);
  
  // Colors for different years
  const colors = ['#52c41a', '#1890ff', '#faad14'];

  return (
    <Card title="Evolución Mensual de Auditorías Completadas - Comparativa por Campaña">
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="month_name" />
          <YAxis />
          <Tooltip />
          <Legend />
          {years.map((year, index) => (
            <Line
              key={year}
              type="monotone"
              dataKey={`year_${year}`}
              stroke={colors[index % colors.length]}
              strokeWidth={2}
              name={`Campaña ${year}`}
              dot={{ r: 4 }}
              activeDot={{ r: 6 }}
              connectNulls
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </Card>
  );
};
